import { render, staticRenderFns } from "./putongReport.vue?vue&type=template&id=d32f4228&scoped=true&"
import script from "./putongReport.vue?vue&type=script&lang=js&"
export * from "./putongReport.vue?vue&type=script&lang=js&"
import style0 from "./putongReport.vue?vue&type=style&index=0&id=d32f4228&scoped=true&lang=less&"
import style1 from "./putongReport.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f4228",
  null
  
)

export default component.exports